import React from 'react';
import PropTypes from 'prop-types';
import DefaultView from './DefaultView';
import { LAYOUT_BATCH_MODE } from '../../layout';
import BatchView from './BatchView';
import getShipment from '../../helpers/shipment';

const otherGroupProps = rows => {
  const shipments = rows.map(getShipment).filter(Boolean);

  return {
    completed: shipments.length > 0 && shipments.every(shipment => shipment.completed),
    shippingLabelPrinted:
      shipments.length > 0 && shipments.every(shipment => shipment.shipping_label_printed === true),
    patientsLabelPrinted:
      shipments.length > 0 && shipments.every(shipment => shipment.patient_label_printed === true)
  };
};

const groupPatients = rows => {
  const groups = {};
  const orderedGroups = [];

  rows.forEach(value => {
    const shipment = getShipment(value);

    const groupData = {
      location: shipment ? shipment.location : null,
      shippingMethod: shipment && shipment.shipping_method ? shipment.shipping_method.name : '',
      shipDate: shipment ? shipment.ship_date : null,
      assignment: shipment ? shipment.assigned_to : null,
      courier: shipment ? shipment.courier : null,
      organization: value.organization
    };
    const groupId = value.bundled_shipment_id || `patient-${value.id}`;
    const isRush = value.rx_form !== null && value.rx_form.rush_case;

    if (groups[groupId]) {
      const currentGroup = groups[groupId];
      currentGroup.rows.push(value);
      if (currentGroup.shippingMethod !== groupData.shippingMethod && currentGroup.bundledMethod) {
        currentGroup.shippingMethod = 'Mixed';
        currentGroup.bundledMethod = true;
      }
      currentGroup.hasRushCase = currentGroup.hasRushCase || isRush;
    } else {
      const group = {
        ...groupData,
        bundledMethod: false,
        rows: [value],
        keyValue: groupId,
        hasRushCase: isRush
      };
      orderedGroups.push(group);
      groups[groupId] = group;
    }
  });

  return orderedGroups.map(group => {
    const otherProps = otherGroupProps(group.rows);
    return {
      ...group,
      ...otherProps
    };
  });
};

const ShipmentBundling = ({ layout, rows, ...props }) => {
  const groups = groupPatients(rows);

  const Component = layout === LAYOUT_BATCH_MODE ? BatchView : DefaultView;

  return groups.map(groupProps => {
    return <Component {...props} {...groupProps} />;
  });
};

ShipmentBundling.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  rows: PropTypes.array.isRequired
};

export default ShipmentBundling;
